@file:OptIn(InternalResourceApi::class)

package banko.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/banko.composeapp.generated.resources/"

@delegate:ResourceContentHash(614_757_933)
public val Res.string.no_banks_moment: StringResource by lazy {
      StringResource("string:no_banks_moment", "no_banks_moment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12758, 35),
      ))
    }

@delegate:ResourceContentHash(-1_802_005_035)
public val Res.string.no_busts_moment: StringResource by lazy {
      StringResource("string:no_busts_moment", "no_busts_moment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12794, 55),
      ))
    }

@delegate:ResourceContentHash(-1_782_626_780)
public val Res.string.no_pot_moment: StringResource by lazy {
      StringResource("string:no_pot_moment", "no_pot_moment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12850, 37),
      ))
    }

@delegate:ResourceContentHash(435_898_357)
public val Res.string.no_sevens_moment: StringResource by lazy {
      StringResource("string:no_sevens_moment", "no_sevens_moment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12888, 36),
      ))
    }

@delegate:ResourceContentHash(1_771_992_847)
public val Res.string.nudge_button: StringResource by lazy {
      StringResource("string:nudge_button", "nudge_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12925, 28),
      ))
    }

@delegate:ResourceContentHash(954_822_845)
public val Res.string.open_game_stats: StringResource by lazy {
      StringResource("string:open_game_stats", "open_game_stats", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12954, 43),
      ))
    }

@delegate:ResourceContentHash(2_380_941)
public val Res.string.ordinal_1: StringResource by lazy {
      StringResource("string:ordinal_1", "ordinal_1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12998, 21),
      ))
    }

@delegate:ResourceContentHash(2_400_406)
public val Res.string.ordinal_2: StringResource by lazy {
      StringResource("string:ordinal_2", "ordinal_2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13020, 21),
      ))
    }

@delegate:ResourceContentHash(2_345_319)
public val Res.string.ordinal_3: StringResource by lazy {
      StringResource("string:ordinal_3", "ordinal_3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13042, 21),
      ))
    }

@delegate:ResourceContentHash(-563_175_013)
public val Res.string.ordinal_n: StringResource by lazy {
      StringResource("string:ordinal_n", "ordinal_n", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13064, 25),
      ))
    }

@delegate:ResourceContentHash(1_729_925_170)
public val Res.string.pick_player_to_banko: StringResource by lazy {
      StringResource("string:pick_player_to_banko", "pick_player_to_banko", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13090, 68),
      ))
    }

@delegate:ResourceContentHash(1_331_515_430)
public val Res.string.player_already_exists: StringResource by lazy {
      StringResource("string:player_already_exists", "player_already_exists", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13159, 57),
      ))
    }

@delegate:ResourceContentHash(-1_959_854_948)
public val Res.string.player_count_format: StringResource by lazy {
      StringResource("string:player_count_format", "player_count_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13217, 55),
      ))
    }

@delegate:ResourceContentHash(1_489_478_391)
public val Res.string.player_greeting: StringResource by lazy {
      StringResource("string:player_greeting", "player_greeting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13273, 39),
      ))
    }

@delegate:ResourceContentHash(-88_090_560)
public val Res.string.player_turn: StringResource by lazy {
      StringResource("string:player_turn", "player_turn", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13313, 43),
      ))
    }

@delegate:ResourceContentHash(659_631_068)
public val Res.string.players: StringResource by lazy {
      StringResource("string:players", "players", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13395, 27),
      ))
    }

@delegate:ResourceContentHash(-414_414_497)
public val Res.string.players_count: StringResource by lazy {
      StringResource("string:players_count", "players_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13357, 37),
      ))
    }

@delegate:ResourceContentHash(1_333_603_403)
public val Res.string.plus_benefits_title: StringResource by lazy {
      StringResource("string:plus_benefits_title", "plus_benefits_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13423, 55),
      ))
    }

@delegate:ResourceContentHash(-112_138_371)
public val Res.string.plus_pass_ad_failed: StringResource by lazy {
      StringResource("string:plus_pass_ad_failed", "plus_pass_ad_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13479, 99),
      ))
    }

@delegate:ResourceContentHash(-478_620_972)
public val Res.string.plus_pass_body: StringResource by lazy {
      StringResource("string:plus_pass_body", "plus_pass_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13579, 146),
      ))
    }

@delegate:ResourceContentHash(-1_675_581_904)
public val Res.string.plus_pass_endgame_renew_body: StringResource by lazy {
      StringResource("string:plus_pass_endgame_renew_body", "plus_pass_endgame_renew_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13726, 192),
      ))
    }

@delegate:ResourceContentHash(-434_833_909)
public val Res.string.plus_pass_endgame_renew_title: StringResource by lazy {
      StringResource("string:plus_pass_endgame_renew_title", "plus_pass_endgame_renew_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13919, 57),
      ))
    }

@delegate:ResourceContentHash(-1_062_120_929)
public val Res.string.plus_pass_loading: StringResource by lazy {
      StringResource("string:plus_pass_loading", "plus_pass_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13977, 45),
      ))
    }

@delegate:ResourceContentHash(-1_646_602_120)
public val Res.string.plus_pass_pending_hint: StringResource by lazy {
      StringResource("string:plus_pass_pending_hint", "plus_pass_pending_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14023, 90),
      ))
    }

@delegate:ResourceContentHash(1_524_283_037)
public val Res.string.plus_pass_ready: StringResource by lazy {
      StringResource("string:plus_pass_ready", "plus_pass_ready", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14114, 79),
      ))
    }

@delegate:ResourceContentHash(1_230_194_862)
public val Res.string.plus_pass_title: StringResource by lazy {
      StringResource("string:plus_pass_title", "plus_pass_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14194, 43),
      ))
    }

@delegate:ResourceContentHash(-139_948_958)
public val Res.string.plus_pass_watch: StringResource by lazy {
      StringResource("string:plus_pass_watch", "plus_pass_watch", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14238, 39),
      ))
    }

@delegate:ResourceContentHash(-1_395_184_389)
public val Res.string.points_format: StringResource by lazy {
      StringResource("string:points_format", "points_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14278, 37),
      ))
    }

@delegate:ResourceContentHash(-1_181_682_974)
public val Res.string.points_short: StringResource by lazy {
      StringResource("string:points_short", "points_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14356, 32),
      ))
    }

@delegate:ResourceContentHash(-1_181_682_974)
public val Res.string.points_short_format: StringResource by lazy {
      StringResource("string:points_short_format", "points_short_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14316, 39),
      ))
    }

@delegate:ResourceContentHash(-808_661_503)
public val Res.string.practice_dice_dialog_body: StringResource by lazy {
      StringResource("string:practice_dice_dialog_body", "practice_dice_dialog_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14389, 157),
      ))
    }

@delegate:ResourceContentHash(-922_188_830)
public val Res.string.practice_dice_dialog_dismiss: StringResource by lazy {
      StringResource("string:practice_dice_dialog_dismiss", "practice_dice_dialog_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14547, 48),
      ))
    }

@delegate:ResourceContentHash(327_817_292)
public val Res.string.practice_dice_dialog_title: StringResource by lazy {
      StringResource("string:practice_dice_dialog_title", "practice_dice_dialog_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14596, 62),
      ))
    }

@delegate:ResourceContentHash(-1_463_034_359)
public val Res.string.practice_offer_body: StringResource by lazy {
      StringResource("string:practice_offer_body", "practice_offer_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14659, 147),
      ))
    }

@delegate:ResourceContentHash(-1_725_816_592)
public val Res.string.practice_offer_dismiss: StringResource by lazy {
      StringResource("string:practice_offer_dismiss", "practice_offer_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14807, 62),
      ))
    }

@delegate:ResourceContentHash(1_696_998_352)
public val Res.string.practice_offer_play: StringResource by lazy {
      StringResource("string:practice_offer_play", "practice_offer_play", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14870, 55),
      ))
    }

@delegate:ResourceContentHash(-765_293_241)
public val Res.string.practice_offer_title: StringResource by lazy {
      StringResource("string:practice_offer_title", "practice_offer_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14926, 48),
      ))
    }

@delegate:ResourceContentHash(-1_541_329_146)
public val Res.string.price_once: StringResource by lazy {
      StringResource("string:price_once", "price_once", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14975, 38),
      ))
    }

@delegate:ResourceContentHash(-2_026_059_426)
public val Res.string.price_per_month: StringResource by lazy {
      StringResource("string:price_per_month", "price_per_month", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15014, 35),
      ))
    }

@delegate:ResourceContentHash(-2_026_056_633)
public val Res.string.price_per_year: StringResource by lazy {
      StringResource("string:price_per_year", "price_per_year", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15050, 34),
      ))
    }

@delegate:ResourceContentHash(-511_232_521)
public val Res.string.privacy_policy: StringResource by lazy {
      StringResource("string:privacy_policy", "privacy_policy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15085, 42),
      ))
    }

@delegate:ResourceContentHash(-147_153_399)
public val Res.string.public_game: StringResource by lazy {
      StringResource("string:public_game", "public_game", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15903, 27),
      ))
    }

@delegate:ResourceContentHash(-2_132_671_738)
public val Res.string.public_game_description: StringResource by lazy {
      StringResource("string:public_game_description", "public_game_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15128, 83),
      ))
    }

@delegate:ResourceContentHash(902_305_784)
public val Res.string.public_game_safety_note: StringResource by lazy {
      StringResource("string:public_game_safety_note", "public_game_safety_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15212, 179),
      ))
    }

@delegate:ResourceContentHash(-1_239_148_887)
public val Res.string.public_game_stale: StringResource by lazy {
      StringResource("string:public_game_stale", "public_game_stale", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15558, 57),
      ))
    }

@delegate:ResourceContentHash(-1_348_179_709)
public val Res.string.public_game_stale_description: StringResource by lazy {
      StringResource("string:public_game_stale_description", "public_game_stale_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15392, 165),
      ))
    }

@delegate:ResourceContentHash(-2_073_363_496)
public val Res.string.public_games_empty: StringResource by lazy {
      StringResource("string:public_games_empty", "public_games_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15616, 102),
      ))
    }

@delegate:ResourceContentHash(1_365_288_701)
public val Res.string.public_games_live_hint: StringResource by lazy {
      StringResource("string:public_games_live_hint", "public_games_live_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15719, 126),
      ))
    }

@delegate:ResourceContentHash(1_506_956_820)
public val Res.string.public_games_refresh: StringResource by lazy {
      StringResource("string:public_games_refresh", "public_games_refresh", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15846, 56),
      ))
    }

@delegate:ResourceContentHash(944_966_241)
public val Res.string.reaction_bank_description: StringResource by lazy {
      StringResource("string:reaction_bank_description", "reaction_bank_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15931, 45),
      ))
    }

@delegate:ResourceContentHash(-2_000_676_201)
public val Res.string.reaction_button: StringResource by lazy {
      StringResource("string:reaction_button", "reaction_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15977, 39),
      ))
    }

@delegate:ResourceContentHash(-1_855_485_178)
public val Res.string.reaction_cooldown: StringResource by lazy {
      StringResource("string:reaction_cooldown", "reaction_cooldown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16017, 69),
      ))
    }

@delegate:ResourceContentHash(-1_413_975_608)
public val Res.string.reaction_fire_description: StringResource by lazy {
      StringResource("string:reaction_fire_description", "reaction_fire_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16087, 45),
      ))
    }

@delegate:ResourceContentHash(1_204_144_036)
public val Res.string.reaction_picker_title: StringResource by lazy {
      StringResource("string:reaction_picker_title", "reaction_picker_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16133, 53),
      ))
    }

@delegate:ResourceContentHash(262_014_464)
public val Res.string.reaction_roll_description: StringResource by lazy {
      StringResource("string:reaction_roll_description", "reaction_roll_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16187, 49),
      ))
    }

@delegate:ResourceContentHash(-1_316_421_489)
public val Res.string.reaction_shock_description: StringResource by lazy {
      StringResource("string:reaction_shock_description", "reaction_shock_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16237, 58),
      ))
    }

@delegate:ResourceContentHash(-989_177_947)
public val Res.string.reaction_watching_description: StringResource by lazy {
      StringResource("string:reaction_watching_description", "reaction_watching_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16296, 61),
      ))
    }

@delegate:ResourceContentHash(824_308_621)
public val Res.string.reactions_muted: StringResource by lazy {
      StringResource("string:reactions_muted", "reactions_muted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16358, 43),
      ))
    }

@delegate:ResourceContentHash(1_872_678_712)
public val Res.string.refresh_public_listing: StringResource by lazy {
      StringResource("string:refresh_public_listing", "refresh_public_listing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16402, 50),
      ))
    }

@delegate:ResourceContentHash(291_994_477)
public val Res.string.rematch: StringResource by lazy {
      StringResource("string:rematch", "rematch", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16453, 27),
      ))
    }

@delegate:ResourceContentHash(-292_345_136)
public val Res.string.remove_ads: StringResource by lazy {
      StringResource("string:remove_ads", "remove_ads", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16535, 34),
      ))
    }

@delegate:ResourceContentHash(1_111_971_888)
public val Res.string.remove_ads_with_price: StringResource by lazy {
      StringResource("string:remove_ads_with_price", "remove_ads_with_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16481, 53),
      ))
    }

@delegate:ResourceContentHash(-523_897_110)
public val Res.string.remove_player: StringResource by lazy {
      StringResource("string:remove_player", "remove_player", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16570, 41),
      ))
    }

@delegate:ResourceContentHash(558_352_297)
public val Res.string.restore_purchases: StringResource by lazy {
      StringResource("string:restore_purchases", "restore_purchases", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16612, 49),
      ))
    }

@delegate:ResourceContentHash(58_874_026)
public val Res.string.roll_dice: StringResource by lazy {
      StringResource("string:roll_dice", "roll_dice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16662, 29),
      ))
    }

@delegate:ResourceContentHash(-175_576_430)
public val Res.string.round_ended_banked: StringResource by lazy {
      StringResource("string:round_ended_banked", "round_ended_banked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16692, 54),
      ))
    }

@delegate:ResourceContentHash(1_981_848_712)
public val Res.string.round_ended_bust: StringResource by lazy {
      StringResource("string:round_ended_bust", "round_ended_bust", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16792, 48),
      ))
    }

@delegate:ResourceContentHash(-517_638_508)
public val Res.string.round_ended_bust_unknown: StringResource by lazy {
      StringResource("string:round_ended_bust_unknown", "round_ended_bust_unknown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16747, 44),
      ))
    }

@delegate:ResourceContentHash(2_071_660_093)
public val Res.string.round_format: StringResource by lazy {
      StringResource("string:round_format", "round_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16841, 44),
      ))
    }

@delegate:ResourceContentHash(-438_723_709)
public val Res.string.round_in_progress: StringResource by lazy {
      StringResource("string:round_in_progress", "round_in_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16886, 41),
      ))
    }

@delegate:ResourceContentHash(1_105_620_776)
public val Res.string.round_number: StringResource by lazy {
      StringResource("string:round_number", "round_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16928, 36),
      ))
    }

@delegate:ResourceContentHash(1_105_620_776)
public val Res.string.round_overlay: StringResource by lazy {
      StringResource("string:round_overlay", "round_overlay", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16965, 37),
      ))
    }

@delegate:ResourceContentHash(953_589_679)
public val Res.string.round_peak_pot: StringResource by lazy {
      StringResource("string:round_peak_pot", "round_peak_pot", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17003, 42),
      ))
    }

@delegate:ResourceContentHash(-373_408_369)
public val Res.string.round_rolls: StringResource by lazy {
      StringResource("string:round_rolls", "round_rolls", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17046, 35),
      ))
    }

@delegate:ResourceContentHash(1_311_545_642)
public val Res.string.round_top_gain: StringResource by lazy {
      StringResource("string:round_top_gain", "round_top_gain", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17082, 42),
      ))
    }

@delegate:ResourceContentHash(-457_761_570)
public val Res.string.rounds_count_format: StringResource by lazy {
      StringResource("string:rounds_count_format", "rounds_count_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17125, 43),
      ))
    }

@delegate:ResourceContentHash(-457_761_570)
public val Res.string.rounds_format: StringResource by lazy {
      StringResource("string:rounds_format", "rounds_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17169, 37),
      ))
    }

@delegate:ResourceContentHash(-772_739_676)
public val Res.string.rules: StringResource by lazy {
      StringResource("string:rules", "rules", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17207, 21),
      ))
    }

@delegate:ResourceContentHash(483_275_851)
public val Res.string.seasonal_effects: StringResource by lazy {
      StringResource("string:seasonal_effects", "seasonal_effects", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17322, 48),
      ))
    }

@delegate:ResourceContentHash(-1_264_639_072)
public val Res.string.seasonal_effects_description: StringResource by lazy {
      StringResource("string:seasonal_effects_description", "seasonal_effects_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17229, 92),
      ))
    }

@delegate:ResourceContentHash(1_105_064_789)
public val Res.string.see_full_game_stats: StringResource by lazy {
      StringResource("string:see_full_game_stats", "see_full_game_stats", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17371, 55),
      ))
    }

@delegate:ResourceContentHash(2_128_509_713)
public val Res.string.setting_prefix: StringResource by lazy {
      StringResource("string:setting_prefix", "setting_prefix", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17427, 34),
      ))
    }

@delegate:ResourceContentHash(2_128_440_428)
public val Res.string.settings: StringResource by lazy {
      StringResource("string:settings", "settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17608, 28),
      ))
    }

@delegate:ResourceContentHash(1_613_373_947)
public val Res.string.settings_offline_locked: StringResource by lazy {
      StringResource("string:settings_offline_locked", "settings_offline_locked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17462, 95),
      ))
    }

@delegate:ResourceContentHash(814_385_830)
public val Res.string.settings_offline_mode: StringResource by lazy {
      StringResource("string:settings_offline_mode", "settings_offline_mode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17558, 49),
      ))
    }

@delegate:ResourceContentHash(-1_188_837_237)
public val Res.string.seven_magnet: StringResource by lazy {
      StringResource("string:seven_magnet", "seven_magnet", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17637, 36),
      ))
    }

@delegate:ResourceContentHash(-443_451_939)
public val Res.string.sevens_count: StringResource by lazy {
      StringResource("string:sevens_count", "sevens_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17674, 36),
      ))
    }

@delegate:ResourceContentHash(-259_309_123)
public val Res.string.share_invite: StringResource by lazy {
      StringResource("string:share_invite", "share_invite", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17711, 36),
      ))
    }

@delegate:ResourceContentHash(-2_022_170_990)
public val Res.string.share_recap: StringResource by lazy {
      StringResource("string:share_recap", "share_recap", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17748, 35),
      ))
    }

@delegate:ResourceContentHash(814_385_830)
public val Res.string.single_device: StringResource by lazy {
      StringResource("string:single_device", "single_device", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18051, 41),
      ))
    }

@delegate:ResourceContentHash(827_846_662)
public val Res.string.single_device_desc: StringResource by lazy {
      StringResource("string:single_device_desc", "single_device_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17784, 266),
      ))
    }

@delegate:ResourceContentHash(1_374_173_703)
public val Res.string.snackbar_game_finished: StringResource by lazy {
      StringResource("string:snackbar_game_finished", "snackbar_game_finished", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18093, 86),
      ))
    }

@delegate:ResourceContentHash(-1_811_465_669)
public val Res.string.snackbar_game_unavailable: StringResource by lazy {
      StringResource("string:snackbar_game_unavailable", "snackbar_game_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18180, 77),
      ))
    }

@delegate:ResourceContentHash(1_383_060_335)
public val Res.string.snackbar_player_kicked: StringResource by lazy {
      StringResource("string:snackbar_player_kicked", "snackbar_player_kicked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18258, 82),
      ))
    }

@delegate:ResourceContentHash(171_916_122)
public val Res.string.start_game: StringResource by lazy {
      StringResource("string:start_game", "start_game", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18427, 34),
      ))
    }

@delegate:ResourceContentHash(-192_218_751)
public val Res.string.start_game_needs_players_hint: StringResource by lazy {
      StringResource("string:start_game_needs_players_hint", "start_game_needs_players_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18341, 85),
      ))
    }

@delegate:ResourceContentHash(467_974_057)
public val Res.string.start_single_device_game: StringResource by lazy {
      StringResource("string:start_single_device_game", "start_single_device_game", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18462, 64),
      ))
    }

@delegate:ResourceContentHash(72_013_164)
public val Res.string.stats_avg_bank: StringResource by lazy {
      StringResource("string:stats_avg_bank", "stats_avg_bank", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18527, 34),
      ))
    }

@delegate:ResourceContentHash(-497_596_499)
public val Res.string.stats_banks: StringResource by lazy {
      StringResource("string:stats_banks", "stats_banks", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18562, 27),
      ))
    }

@delegate:ResourceContentHash(1_889_967_777)
public val Res.string.stats_best_bank: StringResource by lazy {
      StringResource("string:stats_best_bank", "stats_best_bank", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18590, 35),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("no_banks_moment", Res.string.no_banks_moment)
  map.put("no_busts_moment", Res.string.no_busts_moment)
  map.put("no_pot_moment", Res.string.no_pot_moment)
  map.put("no_sevens_moment", Res.string.no_sevens_moment)
  map.put("nudge_button", Res.string.nudge_button)
  map.put("open_game_stats", Res.string.open_game_stats)
  map.put("ordinal_1", Res.string.ordinal_1)
  map.put("ordinal_2", Res.string.ordinal_2)
  map.put("ordinal_3", Res.string.ordinal_3)
  map.put("ordinal_n", Res.string.ordinal_n)
  map.put("pick_player_to_banko", Res.string.pick_player_to_banko)
  map.put("player_already_exists", Res.string.player_already_exists)
  map.put("player_count_format", Res.string.player_count_format)
  map.put("player_greeting", Res.string.player_greeting)
  map.put("player_turn", Res.string.player_turn)
  map.put("players", Res.string.players)
  map.put("players_count", Res.string.players_count)
  map.put("plus_benefits_title", Res.string.plus_benefits_title)
  map.put("plus_pass_ad_failed", Res.string.plus_pass_ad_failed)
  map.put("plus_pass_body", Res.string.plus_pass_body)
  map.put("plus_pass_endgame_renew_body", Res.string.plus_pass_endgame_renew_body)
  map.put("plus_pass_endgame_renew_title", Res.string.plus_pass_endgame_renew_title)
  map.put("plus_pass_loading", Res.string.plus_pass_loading)
  map.put("plus_pass_pending_hint", Res.string.plus_pass_pending_hint)
  map.put("plus_pass_ready", Res.string.plus_pass_ready)
  map.put("plus_pass_title", Res.string.plus_pass_title)
  map.put("plus_pass_watch", Res.string.plus_pass_watch)
  map.put("points_format", Res.string.points_format)
  map.put("points_short", Res.string.points_short)
  map.put("points_short_format", Res.string.points_short_format)
  map.put("practice_dice_dialog_body", Res.string.practice_dice_dialog_body)
  map.put("practice_dice_dialog_dismiss", Res.string.practice_dice_dialog_dismiss)
  map.put("practice_dice_dialog_title", Res.string.practice_dice_dialog_title)
  map.put("practice_offer_body", Res.string.practice_offer_body)
  map.put("practice_offer_dismiss", Res.string.practice_offer_dismiss)
  map.put("practice_offer_play", Res.string.practice_offer_play)
  map.put("practice_offer_title", Res.string.practice_offer_title)
  map.put("price_once", Res.string.price_once)
  map.put("price_per_month", Res.string.price_per_month)
  map.put("price_per_year", Res.string.price_per_year)
  map.put("privacy_policy", Res.string.privacy_policy)
  map.put("public_game", Res.string.public_game)
  map.put("public_game_description", Res.string.public_game_description)
  map.put("public_game_safety_note", Res.string.public_game_safety_note)
  map.put("public_game_stale", Res.string.public_game_stale)
  map.put("public_game_stale_description", Res.string.public_game_stale_description)
  map.put("public_games_empty", Res.string.public_games_empty)
  map.put("public_games_live_hint", Res.string.public_games_live_hint)
  map.put("public_games_refresh", Res.string.public_games_refresh)
  map.put("reaction_bank_description", Res.string.reaction_bank_description)
  map.put("reaction_button", Res.string.reaction_button)
  map.put("reaction_cooldown", Res.string.reaction_cooldown)
  map.put("reaction_fire_description", Res.string.reaction_fire_description)
  map.put("reaction_picker_title", Res.string.reaction_picker_title)
  map.put("reaction_roll_description", Res.string.reaction_roll_description)
  map.put("reaction_shock_description", Res.string.reaction_shock_description)
  map.put("reaction_watching_description", Res.string.reaction_watching_description)
  map.put("reactions_muted", Res.string.reactions_muted)
  map.put("refresh_public_listing", Res.string.refresh_public_listing)
  map.put("rematch", Res.string.rematch)
  map.put("remove_ads", Res.string.remove_ads)
  map.put("remove_ads_with_price", Res.string.remove_ads_with_price)
  map.put("remove_player", Res.string.remove_player)
  map.put("restore_purchases", Res.string.restore_purchases)
  map.put("roll_dice", Res.string.roll_dice)
  map.put("round_ended_banked", Res.string.round_ended_banked)
  map.put("round_ended_bust", Res.string.round_ended_bust)
  map.put("round_ended_bust_unknown", Res.string.round_ended_bust_unknown)
  map.put("round_format", Res.string.round_format)
  map.put("round_in_progress", Res.string.round_in_progress)
  map.put("round_number", Res.string.round_number)
  map.put("round_overlay", Res.string.round_overlay)
  map.put("round_peak_pot", Res.string.round_peak_pot)
  map.put("round_rolls", Res.string.round_rolls)
  map.put("round_top_gain", Res.string.round_top_gain)
  map.put("rounds_count_format", Res.string.rounds_count_format)
  map.put("rounds_format", Res.string.rounds_format)
  map.put("rules", Res.string.rules)
  map.put("seasonal_effects", Res.string.seasonal_effects)
  map.put("seasonal_effects_description", Res.string.seasonal_effects_description)
  map.put("see_full_game_stats", Res.string.see_full_game_stats)
  map.put("setting_prefix", Res.string.setting_prefix)
  map.put("settings", Res.string.settings)
  map.put("settings_offline_locked", Res.string.settings_offline_locked)
  map.put("settings_offline_mode", Res.string.settings_offline_mode)
  map.put("seven_magnet", Res.string.seven_magnet)
  map.put("sevens_count", Res.string.sevens_count)
  map.put("share_invite", Res.string.share_invite)
  map.put("share_recap", Res.string.share_recap)
  map.put("single_device", Res.string.single_device)
  map.put("single_device_desc", Res.string.single_device_desc)
  map.put("snackbar_game_finished", Res.string.snackbar_game_finished)
  map.put("snackbar_game_unavailable", Res.string.snackbar_game_unavailable)
  map.put("snackbar_player_kicked", Res.string.snackbar_player_kicked)
  map.put("start_game", Res.string.start_game)
  map.put("start_game_needs_players_hint", Res.string.start_game_needs_players_hint)
  map.put("start_single_device_game", Res.string.start_single_device_game)
  map.put("stats_avg_bank", Res.string.stats_avg_bank)
  map.put("stats_banks", Res.string.stats_banks)
  map.put("stats_best_bank", Res.string.stats_best_bank)
}
